var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import renderTemplate from './_promotional-card.hbs';
import './promotional-card.scss';
import { getPropertiesFromClassName, NO_PATTERN_BUSINESS_LOGIC, Pattern, removeUndefinedFieldsFromObject, } from '@vfde-brix/ws10/core';
import { PROMOTIONAL_CARD_CONFIRMATION_TEXT_CLASSNAME, PROMOTIONAL_CARD_CONFIRMATION_TEXT_SHOW_CLASSNAME, PROMOTIONAL_CARD_FLAG_BADGE_CLASSNAME, PROMOTIONAL_CARD_ICON_CLASSNAME, PROMOTIONAL_CARD_SUBLABEL_CLASSNAME, PROMOTIONAL_CARD_FORM_SELECTION_CONTROL_CONTAINER, PromotionalCardVariant, PROMOTIONAL_CARD_DEFAULT_TAG, PROMOTIONAL_CARD_LABEL_CLASSNAME, PROMOTIONAL_CARD_BASE_CLASSNAME, PROMOTIONAL_CARD_VARIANTS, } from './Constants';
import { createFlagBadge, } from '@vfde-brix/ws10/flag-badge';
import { createFormSelectionControl, } from '@vfde-brix/ws10/form-selection-control';
import { getSystemIconName } from '@vfde-brix/ws10/system-icon';
/**
 * Promotional Card
 */
var PromotionalCard = /** @class */ (function (_super) {
    __extends(PromotionalCard, _super);
    function PromotionalCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Intentionally return same props. Because no default props to set, but abstract needs implementation
     */
    PromotionalCard.prototype.getDefaultProperties = function (newProperties) {
        newProperties.optVariant || (newProperties.optVariant = PromotionalCardVariant.Standalone);
        newProperties.optTag || (newProperties.optTag = PROMOTIONAL_CARD_DEFAULT_TAG);
        return newProperties;
    };
    PromotionalCard.prototype.initDom = function () {
        this.mountFormSelectionControl();
        this.mountFlagBadge();
    };
    PromotionalCard.prototype.mountFlagBadge = function () {
        var _a;
        this.flagBadgeContainerElement = this.containerElement
            .getElementsByClassName(PROMOTIONAL_CARD_FLAG_BADGE_CLASSNAME)[0];
        this.flagBadgeComponent = this.flagBadgeContainerElement && createFlagBadge(this.flagBadgeContainerElement, 
        // if there are properties already, it is writeDom, otherwise readDom
        ((_a = this.properties) === null || _a === void 0 ? void 0 : _a.containerFlagBadge) || NO_PATTERN_BUSINESS_LOGIC);
    };
    PromotionalCard.prototype.mountFormSelectionControl = function () {
        var _this = this;
        var _a, _b;
        this.formSelectionControlContainerElement = this.containerElement
            .getElementsByClassName(PROMOTIONAL_CARD_FORM_SELECTION_CONTROL_CONTAINER)[0];
        if (!this.formSelectionControlContainerElement) {
            return;
        }
        var onChange = function (event, value, isChecked) {
            var _a, _b;
            (_b = (_a = _this.properties.business) === null || _a === void 0 ? void 0 : _a.onChange) === null || _b === void 0 ? void 0 : _b.call(_a, event, value, isChecked);
            _this.handleformSelectionControlChange();
        };
        var formSelectionControlProps = ((_a = this.properties) === null || _a === void 0 ? void 0 : _a.containerFormSelectionControl) ? __assign(__assign({}, (_b = this.properties) === null || _b === void 0 ? void 0 : _b.containerFormSelectionControl), { business: {
                onChange: onChange,
            } }) : undefined;
        this.formSelectionControlComponent = createFormSelectionControl(this.formSelectionControlContainerElement, 
        // if there are properties already, it is writeDom, otherwise readDom
        formSelectionControlProps || { onChange: onChange });
    };
    /**
     * All rendering gets done with this function. If the component contains another
     * component, you would then render the child component in this function.
     */
    PromotionalCard.prototype.writeDom = function () {
        this.containerElement.innerHTML = renderTemplate(this.properties);
    };
    /**
     * This is an abstract function so you have to implement it.
     */
    PromotionalCard.prototype.readDom = function (promotionalCardBusinessLogic) {
        var _a, _b, _c;
        var promotionalCardElement = this.containerElement.getElementsByClassName(PROMOTIONAL_CARD_BASE_CLASSNAME)[0];
        var stdSystemIconName = getSystemIconName(promotionalCardElement.getElementsByClassName(PROMOTIONAL_CARD_ICON_CLASSNAME)[0]);
        var txtSublabel = promotionalCardElement
            .getElementsByClassName(PROMOTIONAL_CARD_SUBLABEL_CLASSNAME)[0]
            .innerHTML.replace(/\s+/g, ' ')
            .trim();
        var stdConfirmationText = (_a = promotionalCardElement
            .getElementsByClassName(PROMOTIONAL_CARD_CONFIRMATION_TEXT_CLASSNAME)[0]) === null || _a === void 0 ? void 0 : _a.innerHTML.trim();
        var containerFormSelectionControl = (_b = this.formSelectionControlComponent) === null || _b === void 0 ? void 0 : _b.getProperties();
        var containerFlagBadge = (_c = this.flagBadgeComponent) === null || _c === void 0 ? void 0 : _c.getProperties();
        var headlineElement = promotionalCardElement.getElementsByClassName(PROMOTIONAL_CARD_LABEL_CLASSNAME)[0];
        var optTag = headlineElement.tagName.toLowerCase();
        var optVariant = getPropertiesFromClassName(promotionalCardElement.className, {
            optVariant: PROMOTIONAL_CARD_VARIANTS,
        }).optVariant;
        var stdLabel = headlineElement.innerHTML.trim();
        return removeUndefinedFieldsFromObject({
            optTag: optTag,
            optVariant: optVariant,
            stdLabel: stdLabel,
            stdSystemIconName: stdSystemIconName,
            txtSublabel: txtSublabel,
            containerFormSelectionControl: containerFormSelectionControl,
            stdConfirmationText: stdConfirmationText,
            containerFlagBadge: containerFlagBadge,
            business: promotionalCardBusinessLogic,
        });
    };
    /**
     * Event to handle formSelectionControl text visibility if formSelectionControl changes
     */
    PromotionalCard.prototype.handleformSelectionControlChange = function () {
        var formSelectionControlCheckbox = this.formSelectionControlContainerElement.getElementsByTagName('input')[0];
        var confirmationTextElement = this.containerElement
            .getElementsByClassName(PROMOTIONAL_CARD_CONFIRMATION_TEXT_CLASSNAME)[0];
        confirmationTextElement.classList.toggle(PROMOTIONAL_CARD_CONFIRMATION_TEXT_SHOW_CLASSNAME, formSelectionControlCheckbox.checked);
    };
    return PromotionalCard;
}(Pattern));
export { PromotionalCard };
/**
 * This function returns an instance of PromotionalCard
 */
export var createPromotionalCard = function (containerElement, businessLogicOrProperties) {
    var promotionalCard = new PromotionalCard(containerElement, businessLogicOrProperties);
    promotionalCard.init();
    return promotionalCard;
};
